module.exports = __webpack_public_path__ + "static/media/record.9f0b5755.svg";